/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Account page methods
 * -----------------------------------------------------------------------------
 *
 * @namespace account
 */

import password from 'password-strength-meter';

var accountMethods = {

  methods: {
    _initAccount: function _initAccount() {
      if (app.currentTemplate !== 'account') {
        return;
      }

      var $accountTabs = $(app.selectors.accountTabs);
      var $loginForm = $(app.selectors.loginForm);
      var $recoverForm = $(app.selectors.recoverForm);
      var $passwordInput = $(app.selectors.passwordInput);
      var hash = window.location.hash;

      // account tabs => url hash
      hash && $accountTabs.find("ul.nav a[href=\"" + hash + "\"]").tab('show');

      $accountTabs.find('.nav a').click(function (e) {
        window.location.hash = $(this).attr('href');
      });

      function showRecoverPasswordForm() {
        $recoverForm.fadeIn();
        $loginForm.hide();
        $('[data-account-title]').fadeIn().html('¿Olvidaste tu contraseña?');
        app.storeUtilities.loginHelper.isLoginFormVisible = false;
      }

      function hideRecoverPasswordForm() {
        $recoverForm.hide();
        $loginForm.fadeIn();
        $('[data-account-title]').fadeIn().html('INICIAR SESIÓN');
        app.storeUtilities.loginHelper.isLoginFormVisible = true;
      }

      // allow deep linking to the recover password form
      if (hash === '#recover') {
        $accountTabs.find('ul.nav a[href="#login"]').tab('show');
        showRecoverPasswordForm();
      }

      $(document).on('click', '[data-register-link]', function () {
        $accountTabs.find('ul.nav a[href="#register"]').tab('show');
      });

      $(document).on('click', '[data-recover-link]', function () {
        showRecoverPasswordForm();
      });

      $(document).on('click', '[data-cancel-recover-link]', function () {
        hideRecoverPasswordForm();
      });

      // password strength meter
      $passwordInput.password({
        shortPass: 'The password is too short',
        badPass: 'Weak; try combining letters & numbers',
        goodPass: 'Medium; try using special characters',
        strongPass: 'Strong password',
        containsUsername: 'The password contains the username',
        enterPass: 'Escribe una nueva contraseña',
        showPercent: false,
        showText: true, // shows the text tips
        animate: true, // whether or not to animate the progress bar on input blur/focus
        animateSpeed: 'fast', // the above animation speed
        username: false, // select the username field (selector or jQuery instance) for better password checks
        usernamePartialMatch: false, // whether to check for username partials
        minimumLength: 6 // minimum password length (below this threshold, the score is 0)
      });

      // toggle collapse for edit address
      // show one card at a time

      $(document).on('click', '.remove-address', function () {
        $(this).next('span').find('a')[0].click();
      });
      $(document).on('click', '[data-makedefault-address]', function () {
        var target = $(this).data('target');
        var thisform = $(target).find('form');
        thisform.find('.checkbox-makedefault').prop('checked', true).trigger('change');
        setTimeout(function () {
          thisform.submit();
        }, 300);
      });

      $(document).on('click', '[data-edit-address]', function () {
        var target = $(this).data('target');

        var addressRegion = $(target).find('[data-regions]').attr('data-preselected');
        var addressCommuna = $(target).find('[data-district]').attr('data-preselected');
        $(target).find('[data-regions]').find('option[data-region_code="' + addressRegion + '"]').attr('selected', 'selected').trigger('change');
        setTimeout(function () {
          $(target).find('[data-district]').find('option[value="' + addressCommuna + '"]').attr('selected', 'selected').trigger('change');
        }, 500);

        $('.collapse').collapse('hide');
        $(target).collapse('show');

        $('html').animate({
          scrollTop: $(target).offset().top
        }, 400);

        // unlock window - fix scrolltop common problem
        $(window).bind('mousewheel', function () {
          $('html').stop();
        });
      });

      app._initShopifyAccountMethods();
    },
    _initShopifyAccountMethods: function _initShopifyAccountMethods() {
      if ($('[data-account-address]').length === 0) {
        return;
      }

      var addressesIds = JSON.parse($('[data-account-json]').html()).addressesIds;

      if ($('[data-account-address]').length > 0 && $('#AddressCountryNew').length > 0) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew'
        });
      }

      addressesIds.forEach(function (id) {
        if ($("#AddressCountry_" + id).length > 0) {
          new Shopify.CountryProvinceSelector("AddressCountry_" + id, "AddressProvince_" + id, {
            hideElement: "AddressProvinceContainer_" + id
          });
        }
      });

      Shopify.CustomerAddress = {
        destroy: function destroy(id, confirm_msg) {
          if (confirm(confirm_msg || '¿Estás seguro de que deseas eliminar esta dirección?')) {
            Shopify.postLink("/account/addresses/" + id, {
              parameters: { _method: 'delete' }
            });
          }
        }
      };
    }
  }
};

export default accountMethods;